var map = {
	"./01_Ihl-Architektur_01_Feel.jpg": 4715,
	"./01_Ihl-Architektur_02_Feel.jpg": 2057,
	"./01_Ihl-Architektur_03_Feel.jpg": 8218,
	"./02_Ihl-Architektur_01_Dockville.jpg": 8921,
	"./02_Ihl-Architektur_02_Dockville.jpg": 4522,
	"./02_Ihl-Architektur_03_Dockville.jpg": 7920,
	"./02_Ihl-Architektur_04_Dockville.jpg": 2280,
	"./02_Ihl-Architektur_05_Dockville.jpg": 5114,
	"./02_Ihl-Architektur_06_Dockville.jpg": 5786,
	"./03_Ihl-Architektur_01_Bucht der Träumer.jpg": 5272,
	"./03_Ihl-Architektur_02_Bucht der Träumer.jpg": 585,
	"assets/d1_feel/01_Ihl-Architektur_01_Feel.jpg": 4715,
	"assets/d1_feel/01_Ihl-Architektur_02_Feel.jpg": 2057,
	"assets/d1_feel/01_Ihl-Architektur_03_Feel.jpg": 8218,
	"assets/d1_feel/02_Ihl-Architektur_01_Dockville.jpg": 8921,
	"assets/d1_feel/02_Ihl-Architektur_02_Dockville.jpg": 4522,
	"assets/d1_feel/02_Ihl-Architektur_03_Dockville.jpg": 7920,
	"assets/d1_feel/02_Ihl-Architektur_04_Dockville.jpg": 2280,
	"assets/d1_feel/02_Ihl-Architektur_05_Dockville.jpg": 5114,
	"assets/d1_feel/02_Ihl-Architektur_06_Dockville.jpg": 5786,
	"assets/d1_feel/03_Ihl-Architektur_01_Bucht der Träumer.jpg": 5272,
	"assets/d1_feel/03_Ihl-Architektur_02_Bucht der Träumer.jpg": 585
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2579;